var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6303 0.552206L17.7012 7.30163C17.892 7.48367 18 7.73593 18 7.99988C18 8.26383 17.892 8.51573 17.7012 8.69812L10.6303 15.4475C10.2449 15.8141 9.63481 15.8003 9.2668 15.4149C8.89896 15.0332 8.91278 14.4206 9.29945 14.0514L14.6307 8.96519H0.964606C0.432285 8.96519 0 8.5329 0 8.00058C0 7.46826 0.432285 7.03678 0.964606 7.03678H14.6282L9.29694 1.9506C8.91085 1.58069 8.8988 0.968018 9.26439 0.585149C9.634 0.199468 10.2085 0.185808 10.6303 0.552206Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.5d03e8f9056f71f2f2985324664904cb.svg";
export { ForwardRef as ReactComponent };